import {
    CHECK_AUTH,
    CHECK_AUTH_SUCCESS,
    CHECK_AUTH_FAIL,

    PERFORM_LOGOUT
} from '../Actions/ActionsAdmin'

export const ReducerAdmin = (state = {
    user: null
}, action) => {
    switch (action.type) {
        case CHECK_AUTH:
            return {
                ...state,
                user: action.payload.user
            }
        case CHECK_AUTH_SUCCESS:
            return {
                ...state,
                user: action.payload
            }
        case CHECK_AUTH_FAIL:
            return {
                ...state,
                user: null
            }
        case PERFORM_LOGOUT:
            return {
                ...state,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/ReducerAdmin.js